/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Price_No_Bookings_TitleInputs */

const es_landing_price_no_bookings_title = /** @type {(inputs: Landing_Price_No_Bookings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin reservas, 0 €.`)
};

const gl_landing_price_no_bookings_title = /** @type {(inputs: Landing_Price_No_Bookings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sen reservas, 0 €.`)
};

const en_landing_price_no_bookings_title = /** @type {(inputs: Landing_Price_No_Bookings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No bookings, €0.`)
};

/**
* | output |
* | --- |
* | "No bookings, €0." |
*
* @param {Landing_Price_No_Bookings_TitleInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const landing_price_no_bookings_title = /** @type {((inputs?: Landing_Price_No_Bookings_TitleInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Price_No_Bookings_TitleInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_landing_price_no_bookings_title(inputs)
	if (locale === "en") return en_landing_price_no_bookings_title(inputs)
	return es_landing_price_no_bookings_title(inputs)
});